import { render, staticRenderFns } from "./nq5c-AW2025.vue?vue&type=template&id=2700e264&scoped=true"
import script from "./nq5c-AW2025.vue?vue&type=script&lang=js"
export * from "./nq5c-AW2025.vue?vue&type=script&lang=js"
import style0 from "./nq5c-AW2025.vue?vue&type=style&index=0&id=2700e264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700e264",
  null
  
)

export default component.exports